import { cookies, requests } from '..';
import { SessionRepositoryApi } from './SessionRepositoryApi';

export const OTP_METHODS = [`sms`, `whatsapp`] as const;
export type OTP_METHOD = (typeof OTP_METHODS)[number];

export const sessionRepository = new SessionRepositoryApi(requests, cookies);
